import PropTypes from "prop-types"
import { useState } from 'react'
import intl from 'react-intl-universal'
import * as S from './styled'
import Filter from '../filter';
import Sidebar from "components/sidebar";
import ButtonIcon from "components/button-icon";
import { IconFilterActive } from "components/icons/icn-filter-active.icon";
import { IconFilterInactive } from "components/icons/icn-filter-inactive.icon";

const ButtonFilterSuggestion = ({ isFiltered, stopLoading, startLoading }) => {
  const [openForms, setOpenForms] = useState(false);
  const handleClose = () => setOpenForms(false);
  const getFilterIcon = () =>{ 
    if(localStorage.getItem("THEME") != 1 ){
      if(isFiltered) 
       return <IconFilterActive />; 
      else
       return <IconFilterInactive />;
    }else
      return undefined
  }
  return (
    <S.Wrapper>
      <ButtonIcon
        onClick={() => setOpenForms(prevState => !prevState)}
        buttonType='secondary'
        buttonText={intl.get('filters.filter')}
        buttonIcon={getFilterIcon()}
        style={{ width: '170px' }}
      />
      <Sidebar
        visible={openForms}
        triggerClose={handleClose}
      >
        <Filter
          handleClose={handleClose}
          startLoading={startLoading}
          stopLoading={stopLoading}
        />
      </Sidebar>
    </S.Wrapper>
  )
}

ButtonFilterSuggestion.propTypes = {
  isFiltered: PropTypes.any.isRequired,
  startLoading: PropTypes.any.isRequired,
  stopLoading: PropTypes.any.isRequired
}

export default ButtonFilterSuggestion;
